import { render } from "./returnCar.vue?vue&type=template&id=2133adff&scoped=true"
import script from "./returnCar.vue?vue&type=script&lang=js"
export * from "./returnCar.vue?vue&type=script&lang=js"

import "./returnCar.vue?vue&type=style&index=0&id=2133adff&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2133adff"]])

export default __exports__